import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import * as fromStore from 'src/app/store';

export const InvoiceAttachmentsGuard = (): Observable<boolean> => {
  const store = inject(Store<fromStore.BillingState>);

  const checkStore = (): Observable<boolean> =>
    store.select(fromStore.getInvoiceAttachmentsLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          store.dispatch(new fromStore.LoadInvoiceAttachments());
        }
      }),
      filter((loaded) => loaded),
      take(1),
    );

  return checkStore().pipe(
    switchMap(() => of(true)),
    catchError(() => of(false)),
  );
};
